<template>
    <div class="connectionContainer">
            <div class="connectionHeader">
                <div class="modal_title"> サービス設定</div>
            </div>
            <div class="connectionContents">
                <div class="modal_body">
                    <div class="modal_form">
                        <h3><span>【{{ this.service_setting.service.id }}】</span>{{ this.service_setting.service.name }}</h3>
                        <div class="modal_input">
                            <label>手数料率（％）</label>
                            <input type="text" placeholder="手数料（％）" v-model="service_setting.charge_rate">
                        </div>
                        <p>※手数料の計算に使用されます。 手数料 = 売上 x ( 手数料率 / 100 )</p>
                    </div>
                    <div class="modal_submit">
                        <Button width="100px" @click="updateServiceSetting">更新</Button>
                    </div>
                </div>
            </div>
            <div class="connectionFooter">
            </div>
        </div>
    <!-- </div> -->
</template>

<script>


export default {
    name: 'ServiceSettingModal',
    components: {
    },
    props: {
        serviceSettingId: Number,
    },
    data() {
        return {
            service_setting: { service: {} }
        }
    },
    mounted: function() {
        if (this.serviceSettingId !== null) {
            this.getServiceSetting();
        }
    },
    methods: {
        getServiceSetting: function() {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/serviceSettings/" + this.serviceSettingId)
            .then((res) => {
                this.service_setting = res.data;
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        updateServiceSetting: function() {
            this.$store.dispatch("loading", true);
            const data = {
                charge_rate: this.service_setting.charge_rate,
            }; 
            this.axios.put("/api/serviceSettings/" + this.serviceSettingId, data)
            .then(() => {
                this.modalClose();
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    },
    watch: {
    }
}
</script>

<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            h3 
                font-size: 1.6rem
                font-weight: 700
                margin-bottom: 24px
            p
                font-size: 1.4rem
                color: #777
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center 
                label
                    font-size: 1.4rem
                    width: 30%

                input
                    border: 1px solid $grayColor
                    width: 70%
                    padding: 10px
                    text-align: left
                    width: 100%
                    &:focus
                        outline: 2px solid $mainColor
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
        
    .connectionFooter
        display: flex
        justify-content: start
</style>
